var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtistIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.863,
    height: 19.944,
    viewBox: "0 0 19.863 19.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(19.863 19.944) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M4,1.918S6.857-.773,12.033.22a10.1,10.1,0,0,1,7.818,9.3A10.072,10.072,0,0,1,15.833,18a10.436,10.436,0,0,1-5.7,1.943c-1.469.039-3.254-.635-3.5-2.274-.176-1.192.975-3.635-.715-4.22-.955-.33-1.962.016-2.934-.017C.956,13.362-.083,11.346.005,9.515A10.151,10.151,0,0,1,2.2,3.719,11.958,11.958,0,0,1,4,1.918Z",
    transform: "translate(0 0)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 1.807,
    cy: 1.807,
    rx: 1.807,
    ry: 1.807,
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 4.03, 3.443)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 1.807,
    cy: 1.807,
    rx: 1.807,
    ry: 1.807,
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 8.769, 1.528)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 1.807,
    cy: 1.807,
    rx: 1.807,
    ry: 1.807,
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 13.431, 3.34)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.807,
    cy: 1.807,
    rx: 1.807,
    ry: 1.807,
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 15.42, 7.902)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 1.807,
    cy: 1.807,
    rx: 1.807,
    ry: 1.807,
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 13.452, 12.539)",
    fill: "#efefef"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistIcon);
export default __webpack_public_path__ + "static/media/artist_icon.8bad3ef2.svg";
export { ForwardRef as ReactComponent };